import { useContext, useEffect } from 'react';

import { ToastComponent } from '../../components/ToastComponent';
import {
  PATCH_EDIT_SAM,
  PATCH_EDIT_SAM_ERROR,
  PATCH_EDIT_SAM_SUCCESS,
  PUT_EDIT_SAM,
  PUT_EDIT_SAM_ERROR,
  PUT_EDIT_SAM_SUCCESS,
  GET_SAM_BY_ID,
  GET_SAM_BY_ID_SUCCESS,
  GET_SAM_BY_ID_ERROR,
} from '../../constants/constantsRed';
import { StoreContext } from '../../context/Provider';
import useApi from '../../services/request.service';
import { getCurrentPosition, ICoordinates } from '../../utils/utils';
import { locationPermissionService } from '../../services/locationPermissionService';

export const useEditSam = () => {
  // const context = useContext(StoreContext);
  const {
    patchEditSamState,
    putEditSamState,
    getSamByIdState,
    putDisableSamState,
    putModifyWhiteListState,
  } = useContext(StoreContext);
  // const { dispatchGetSamById } = context;
  const { genericApiCallApiBilling } = useApi();

  const putDisabledSam = async (
    samId: number | undefined,
    statusId: number,
    body: any
  ) => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    putModifyWhiteListState.initPutModifyWhiteList();
    putDisableSamState.initPutDisableSam();
    try {
      const result: any = await genericApiCallApiBilling(
        '/v1.0/sam-inventory/' + samId + '/status/' + statusId,
        'PUT',
        body,
        {},
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );

      if (result.status === 200) {
        ToastComponent('success', '', 'Actualizado correctamente');
        return result;
      }
    } catch (error: any) {
      ToastComponent(
        'warning',
        'Error',
        'Error al deshabilitar el SAM, intente más tarde por favor.'
      );
      patchEditSamState.dispatch({
        type: PATCH_EDIT_SAM_ERROR,
        payload: error.message,
      });
      return 'error';
    }
  };
  const putModifyWhiteList = async (
    samId: number | undefined,
    flagValue: boolean,
    body: any
  ) => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    putModifyWhiteListState.initPutModifyWhiteList();
    try {
      const result: any = await genericApiCallApiBilling(
        '/v1.0/sam-inventory/' + samId + '/white-list/' + flagValue,
        'PUT',
        body,
        {},
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );

      if (result.status === 200) {
        ToastComponent('success', '', 'Actualizado correctamente');
        return result;
      }
    } catch (error: any) {
      ToastComponent(
        'warning',
        'Error',
        'Error al modificar la lista blanca, intente más tarde por favor.'
      );
      putModifyWhiteListState.PutModifyWhiteListError(error.message);
      return 'error';
    }
  };

  const getSamById = async (samId: any, aditionalPath: string = '') => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();

    getSamByIdState.dispatch({ type: GET_SAM_BY_ID });
    try {
      const result: any = await genericApiCallApiBilling(
        '/v1.0/sam-inventory/' + aditionalPath + samId,
        'GET',
        {},
        {},
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );
      if (result.status === 200) {
        const payload = result.data;
        getSamByIdState.dispatch({
          type: GET_SAM_BY_ID_SUCCESS,
          payload: payload,
        });
      }
      return result;
    } catch (error: any) {
      ToastComponent('warning', 'Error', error.message);
      getSamByIdState.dispatch({
        type: GET_SAM_BY_ID_ERROR,
        payload: error.message,
      });
    }
  };

  const putEditSam = async (data: any, headers: any) => {
    putEditSamState.dispatch({ type: PUT_EDIT_SAM });
    try {
      const result: any = await genericApiCallApiBilling(
        '/v1.0/sam-inventory',
        'PUT',
        data,
        {},
        headers
      );
      if (result.status === 200) {
        ToastComponent('success', '', 'Actualizado correctamente');
        const payload = result.data.payload;
        putEditSamState.dispatch({
          type: PUT_EDIT_SAM_SUCCESS,
          payload: payload,
        });
      }
      return result;
    } catch (error: any) {
      ToastComponent('warning', 'Error', error.message);
      putEditSamState.dispatch({
        type: PUT_EDIT_SAM_ERROR,
        payload: error.message,
      });
    }
  };

  return { putDisabledSam, putModifyWhiteList, putEditSam, getSamById };
};
